import { useTranslation } from 'react-i18next'

import { CoverImageField, CoverImageFieldProps } from '@percent/domain/giving'
import { ACCEPTED_BANNER_IMG_FORMATS, ACCEPTED_BANNER_IMG_FORMATS_HUMAN, FILE_SIZE_2MB_HUMAN } from '../constants'

type CoverImageSectionProps = Pick<CoverImageFieldProps, 'value' | 'rawValue' | 'onChange' | 'error'> & {
  opportunityName: string
  handleCoverImageChange: (file: File | string, fileName?: string) => Promise<void>
}

export function CoverImageSection({
  opportunityName,
  handleCoverImageChange,
  ...props
}: Readonly<CoverImageSectionProps>) {
  const { t } = useTranslation()

  return (
    <CoverImageField
      {...props}
      acceptedFileFormats={ACCEPTED_BANNER_IMG_FORMATS}
      label={t('volunteering.opportunity.form.common.overviewSection.coverImageField.label')}
      placeholder={t('volunteering.opportunity.form.common.overviewSection.coverImageField.placeholder', {
        acceptedFileFormats: ACCEPTED_BANNER_IMG_FORMATS_HUMAN,
        maxFileSize: FILE_SIZE_2MB_HUMAN
      })}
      uploadFileButtonLabel={t('button.chooseFile')}
      description={t('volunteering.opportunity.form.common.overviewSection.coverImageField.description')}
    />
  )
}
